import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { OdService } from '../../../services/OdService';

const OdForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Options states
  const [origenesOptions, setOrigenesOptions] = useState([]);
  const [destinosOptions, setDestinosOptions] = useState([]);

  // Load origin/destination options
  useEffect(() => {
    let isMounted = true;
    const fetchOptions = async () => {
      const data = await OdService.obtenerOpcionesForm();
      if (isMounted && data) {
        if (data.origenes && Array.isArray(data.origenes)) {
          setOrigenesOptions(
            data.origenes.map((o) => ({
              value: o.id,
              label: o.od_lugar ? `${o.od_lugar} - ${o.od_lugar_nombre}` : o.od_lugar_nombre,
            }))
          );
        }
        if (data.destinos && Array.isArray(data.destinos)) {
          setDestinosOptions(
            data.destinos.map((d) => ({
              value: d.id,
              label: d.od_lugar ? `${d.od_lugar} - ${d.od_lugar_nombre}` : d.od_lugar_nombre,
            }))
          );
        }
      }
    };
    fetchOptions();
    return () => {
      isMounted = false;
    };
  }, []);

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await OdService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
    };
    return await OdService.guardar(payload);
  }, [id]);

  // Form custom validation: prevent same origin and destination
  const handleValidate = useCallback((values) => {
    if (
      values.id_origen &&
      values.id_destino &&
      String(values.id_origen) === String(values.id_destino)
    ) {
      return { id_destino: 'El origen y el destino no pueden ser el mismo lugar' };
    }
    return null;
  }, []);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'id_origen',
      label: 'Origen',
      type: 'autocomplete',
      col: 6,
      required: true,
      options: origenesOptions,
      placeholder: 'Buscar o seleccionar lugar de origen...',
      validators: [Validators.required('El origen es obligatorio')],
    },
    {
      name: 'id_destino',
      label: 'Destino',
      type: 'autocomplete',
      col: 6,
      required: true,
      options: destinosOptions,
      placeholder: 'Buscar o seleccionar lugar de destino...',
      validators: [Validators.required('El destino es obligatorio')],
    },
  ], [origenesOptions, destinosOptions]);

  return (
    <CatalogForm
      title="Origen y Destino"
      subtitle="Configuración de pares origen - destino para el ruteo de envíos"
      fields={fields}
      initialValues={{
        id_origen: '',
        id_destino: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      validate={handleValidate}
      backUrl="/Catalogo/OrigenesDestinos"
    />
  );
};

export default OdForm;
